import { useState } from "react"
import { Sku } from "../../api/models"
import { buildImageSrcSet } from "./imageSrcSet"

// The sku's name where it acts as a title: its logo when it has one, the
// plain text otherwise. Logos are normalized like product logos
// (logoFrame.ts) and sized by the same CSS heights — "title" inside a
// .page-title, "section" inside section/card/tile titles.
export default function SkuName({ sku, variant, sizes = "200px" }: {
  sku: Pick<Sku, "name" | "logoUrl" | "logoAvailableWidths">
  variant: "title" | "section"
  sizes?: string
}) {
  // Right after an upload the scaler hasn't produced the width variants yet,
  // so the srcset-picked one can 404 while the original already exists —
  // retry with the original alone, and fall back to the text if that fails
  // too (per-URL, so a later logo_url starts over).
  const [failed, setFailed] = useState<{ url: string, original: boolean } | null>(null)
  const logoUrl = sku.logoUrl
  const failure = failed !== null && failed.url === logoUrl ? failed : null
  if (!logoUrl || failure?.original)
    return <>{sku.name}</>
  return (
    <img
      src={logoUrl}
      srcSet={failure ? undefined : buildImageSrcSet(logoUrl, sku.logoAvailableWidths)}
      sizes={sizes}
      alt={sku.name}
      className={variant === "title" ? "product-logo-title" : "product-logo-section"}
      onError={() => setFailed({ url: logoUrl, original: failure !== null || !sku.logoAvailableWidths?.length })}
    />
  )
}
